import { apiAction } from 'bento-ordering/base/utils/apiHelpers';
import {
  FETCH_GOOGLE_MAPS_STATIC_URL_REQUEST,
  FETCH_GOOGLE_MAPS_STATIC_URL_SUCCESS,
  FETCH_GOOGLE_MAPS_STATIC_URL_FAILURE
} from 'bento-ordering/base/actions/actionTypes';
import { GOOGLE_MAPS_STATIC_URL_ENDPOINT } from 'bento-ordering/base/constants/endpoints';

export const fetchGoogleMapsStaticUrl = (
  queryParams = {}
) => async dispatch => {
  const endpoint = GOOGLE_MAPS_STATIC_URL_ENDPOINT;
  const result = await dispatch(
    apiAction(
      endpoint,
      'GET',
      [
        FETCH_GOOGLE_MAPS_STATIC_URL_REQUEST,
        FETCH_GOOGLE_MAPS_STATIC_URL_SUCCESS,
        FETCH_GOOGLE_MAPS_STATIC_URL_FAILURE
      ],
      null,
      queryParams
    )
  );
  return result;
};
